module.exports = __webpack_public_path__ + "close-v1-dd4f8c6a.svg";